import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DraftBlock } from 'cloud-shared-lib';
import * as _ from 'lodash';

@Component({
  templateUrl: './semifinished-product-type-setting-dialog.component.html',
  styleUrls: ['./semifinished-product-type-setting-dialog.component.scss'],
})
export class SemifinishedProductTypeSettingDialogComponent {
  data: DraftBlock[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) data: DraftBlock[]) {
    this.data = _.cloneDeep(data);
  }
}
